var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('table-page-wrapper',{staticClass:"checking-affiliates",attrs:{"title":"Проверяемые партнёры","settings-title":"Проверяемые партнёры","error-text":"Список проверяемых партнёров не загружен","columns":_vm.columns,"filters":_vm.filters,"table-options":_vm.checkAffiliateTable,"create-form":_vm.createAffiliateForm}})
}
var staticRenderFns = []

export { render, staticRenderFns }